import { render, staticRenderFns } from "./IndexAdvantage.vue?vue&type=template&id=6dca8a6c&scoped=true&"
import script from "./IndexAdvantage.vue?vue&type=script&lang=js&"
export * from "./IndexAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./IndexAdvantage.vue?vue&type=style&index=0&id=6dca8a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca8a6c",
  null
  
)

export default component.exports